module.exports = __webpack_public_path__ + "img/img3.e1f728dc.png";